<template>
  <b-container fluid>
    <h1 class="display-title">Tipos de Licencia</h1>
    <b-row class="my-4">
      <b-col md="4">
        <b-btn size="sm" variant="success" v-b-modal.modalNuevo>
          <b-icon icon="plus"></b-icon>&nbsp;&nbsp;Agregar
        </b-btn>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-input-group size="sm">
            <b-form-input v-model="filter" placeholder="Buscar" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''" variant="primary"
                >Limpiar</b-btn
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group size="sm" horizontal label="Por página: " class="mb-0">
          <b-form-select
            size="sm"
            :options="pageOptions"
            v-model="perPage"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="segunda-fila">
      <b-col lg="12">
        <b-table
          ref="tablaTipoLicencia"
          stacked="sm"
          responsive
          striped
          hover
          :items="myProvider"
          :fields="fields"
          :filter="filter"
          @filtered="onFiltered"
          :per-page="perPage"
          :current-page="currentPage"
          empty-filtered-text="No se encontraron registros"
        >
          <template #cell(show_details)="row">
            <b-button
              @click.stop="info(row.item, row.index, $event.target)"
              variant="primary"
              size="sm"
              title="Editar"
            >
              <b-icon icon="edit"></b-icon>
            </b-button>
            <b-button
              @click.stop="modalEliminar(row.item, row.index, $event.target)"
              variant="primary"
              size="sm"
              title="Remover"
            >
              <b-icon icon="trash-alt"></b-icon>
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col md="4">
        <p>
          Mostrando {{ currentPage }} a {{ perPage }} de {{ totalRows }} items
        </p>
      </b-col>
      <b-col md="8">
        <b-pagination
          size="sm"
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
        ></b-pagination>
      </b-col>
    </b-row>

    <!--============================================================================================
                                MODAL NUEVO TIPO DE LICENCIA
================================================================================================
		-->
    <b-modal
      id="modalNuevo"
      ref="modal"
      title="Nuevo Detalle "
      ok-title="Guardar"
      ok-variant="primary"
      cancel-title="Cancelar"
      @shown="limpiarFormulario"
      @ok="crearTipo"
      header-bg-variant="dark"
      header-text-variant="light"
      size="lg"
    >
      <b-container fluid>
        <!-- Formulario nuevo tipo de licencia-->
        <b-form id="frmNuevaLicencia" @submit.stop.prevent="handleSubmit">
          <b-form-row>
            <b-col cols="12">
              <!-- Regimen -->
              <b-form-group
                id="exampleInputGroup6"
                label="Regimen : "
                label-for="exampleInput6"
              >
                <b-form-select
                  v-model="regimenSelected"
                  :options="regimen"
                  class="mb-3"
                  id="selectregimen"
                ></b-form-select>
              </b-form-group>
              <!--Select tipo de licencia-->
              <b-form-group
                id="exampleInputGroup1"
                label="Artículo:"
                label-for="selectTipoLic"
              >
                <b-form-input
                  id="txtArticulo"
                  ref="focusThis"
                  v-model="txtArticulo"
                  type="text"
                ></b-form-input>
              </b-form-group>
              <!--Descripcion-->
              <b-form-group
                id="exampleInputGroup2"
                label="Descripcion:"
                label-for="exampleInput2"
              >
                <b-form-input
                  id="exampleInput2"
                  ref="focusThis"
                  v-model="txtDescripcion"
                  type="text"
                ></b-form-input>
              </b-form-group>
              <!--Detalles-->
              <b-form-group
                id="exampleInputGroup2"
                label="Detalles:"
                label-for="exampleInput2"
              >
                <b-form-textarea
                  id="textarea1"
                  v-model="txtDetalle"
                  :rows="3"
                  :max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <!-- Sector-->
              <b-form-group
                id="exampleInputGroup2"
                label="Sector:"
                label-for="exampleInput2"
              >
                <b-form-select
                  v-model="sectorSelected"
                  :options="sector"
                  class="mb-3"
                  id="selectregimen"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-form>
      </b-container>
    </b-modal>
    <!--Modal Edicion-->
    <b-modal
      id="modalEdicion"
      title="Editar Detalle "
      ok-title="Actualizar"
      ok-variant="success"
      cancel-title="Cancelar"
      @ok="cambiarLicencia"
      header-bg-variant="secondary"
      header-text-variant="light"
    >
      <b-container fluid>
        <!-- Formulario nuevo tipo de licencia-->
        <b-form id="frmEditarLicencia" @submit.stop.prevent="handleSubmit">
          <!-- Primera Fila-->
          <b-form-row>
            <b-col cols="12">
              <!--Select tipo de licencia-->
              <b-form-group
                id="grupoLicencia"
                label="Artículo:"
                label-for="selectTipoLic"
              >
                <b-form-input
                  id="txtArticulo"
                  ref="focusThis"
                  v-model="txtArticulo"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
              <!--Descripcion-->
              <b-form-group
                id="grupoEditar2"
                label="Descripcion:"
                label-for="txtArticuloE"
              >
                <b-form-input
                  id="txtArticuloE"
                  ref="focusThis"
                  v-model="txtArticulo"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <!--Segunda Fila-->
          <b-form-row>
            <!--Antiguedad dias-->
            <b-col cols="4">
              <b-form-group
                id="grupoEditar3"
                label="Antigüedad Dias:"
                label-for="txtAntiguedadE"
              >
                <b-form-input
                  id="txtAntiguedadE"
                  v-model="txtAntiguedad"
                  type="number"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <!--Minimo de dias-->
            <b-col cols="4">
              <b-form-group
                id="grupoEditar4"
                label="Mínimo Dias:"
                label-for="txtMaximoDiasE"
              >
                <b-form-input
                  id="txtMinimoDiasE"
                  v-model="txtMinimoDias"
                  type="number"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <!--Maximo de dias-->
            <b-col cols="4">
              <b-form-group
                id="grupoEditar5"
                label="Máximo Dias:"
                label-for="txtMaximoDiasE"
              >
                <b-form-input
                  id="txtMaximoDiasE"
                  v-model="txtMaximoDias"
                  type="number"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <!--Tercera Fila-->
          <b-form-row>
            <!--Dias regimen-->
            <b-col cols="6">
              <b-form-group
                id="grupoEditar6"
                label="Dias regimen: "
                label-for="selectregimenE"
              >
                <b-form-select
                  v-model="regimenSelected"
                  :options="regimen"
                  class="mb-3"
                  id="selectregimenE"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <!--Porcentaje de sueldo-->
            <b-col cols="6">
              <b-form-group
                id="grupoEditar7"
                label="Sueldo % :"
                label-for="selectPorcentajeE"
              >
                <b-form-select
                  v-model="porcentajeSelected"
                  :options="porcentaje"
                  class="mb-3"
                  id="selectPorcentajeE"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-form>
      </b-container>
    </b-modal>
    <!-- Modal Component -->
    <b-modal
      id="modalEliminar"
      title="Remover Detalle"
      @ok="eliminarTipo"
      ok-variant="success"
      ok-title="Si"
      cancel-title="No"
      header-bg-variant="secondary"
      header-text-variant="light"
    >
      <p class="my-4">¿Esta seguro que desea eliminar este registro ?</p>
    </b-modal>
  </b-container>
</template>
<!-- Scripts-->
<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import axios from "axios";
import DetalleDiasLicenciaSvc from "@/services/detallediaslicencia";
import TipoLicenciaSvc from "@/services/tipolicencia";
import Multiselect from "vue-multiselect";

export default {
  name: 'TipoLicencia',
  mixins: [errorhandler, swalerts],
  // OR register locally
  components: { Multiselect },
  data() {
    return {
      value: {},
      filter: "",
      totalRows: null,
      perPage: 10,
      currentPage: 1,
      pageOptions: [5, 10, 15, 25, 50],
      fields: [
          {
            key: 'Articulo',
            label: 'Articulo',
            sortable: true
          },
          {
            key: 'Descripcion',
            label: 'Descripcion',
            sortable: true
          },
          {
            key: 'Regimen',
            label: 'Regimen',
            sortable: true
          },
          {
            key: 'Sector',
            label: 'Sector',
            sortable: true
          },
          {
            key: 'show_details',
            label: 'Acciones',
            class: "text-center"
          },
      ],
      posts: [],
      options: [],
      selected: null,
      txtArticulo: "",
      txtDescripcion: "",
      txtDetalle: "",
      txtSector: "",
      status: "",
      text: "",
      regimenSelected: null,
      sectorSelected: null,
      porcentajeSelected: null,
      txtMaximoDias: "",
      txtMinimoDias: "",
      txtAntiguedad: "",
      idSeleccionado: "",
      tipolicencia: null,
      regimen: [
        { value: null, text: "--Seleccionar--" },
        { value: "Auxiliar", text: "Auxiliar" },
        { value: "Docente", text: "Docente" },
        { value: "SAED", text: "SAED" }
      ],
      sector: [
        { value: null, text: "--Seleccionar--" },
        { value: "Admin", text: "Admin" },
        { value: "Establecimiento", text: "Establecimiento" }
      ],

      porcentaje: [
        { value: null, text: "--Seleccionar--" },
        { value: 100, text: "100 %" },
        { value: 75, text: "75 %" },
        { value: 50, text: "50 %" },
        { value: 0, text: "0 %" }
      ]
    };
  },
  watch: {
    regimenSelected: function(val, oldVal) {
      console.log("new: %s, old: %s", val, oldVal);
    },
    porcentajeSelected: function(val, oldVal) {
      console.log("new: %s, old: %s", val, oldVal);
    }
  },
  methods: {
    /**
     * Método para crear un nuevo tipo de licencia
     * El regimen puede ser de tipo Auxiliar, Docente y SAED.
     *
     * @param  {[type]} evt [description]
     * @return {[type]}     [description]
     */
    crearTipo(evt) {
      evt.preventDefault();
      if (!this.txtArticulo) {
        alert("Por favor seleccione un artículo");
      } else if (!this.txtArticulo) {
        alert("Por favor complete el campo descripción");
      } else if (!this.txtDescripcion) {
        alert("Por favor indique la antigüedad de dias necesarios");
      } else if (this.regimenSelected == null) {
        alert("Por favor indique si los dias son corridos o no");
      } else {
        this.crearTipoLicencia()
          .then(r => {
            this.showSuccess("Licencia agregada exitosamente");
            this.$refs.tablaTipoLicencia.refresh();
            this.handleSubmit();
          })
          .catch(e => {
            this.errorHandler(e);
          });
      }
    },
    /**
     * [cambiarLicencia description]
     * @return {[type]} [description]
     */
    cambiarLicencia() {
      this.cambiarDetalleDiasLicencia()
        .then(res => {
          this.showSuccess("Detalle actualizado exitosamente");
          this.$refs.tablaTipoLicencia.refresh();
        })
        .catch(e => {
          this.errorHandler(e);
        });
    },
    //  eliminar licencia
    eliminarTipo() {
      this.eliminarTipoLicencia()
        .then(res => {
          this.showSuccess("Detalle removido exitosamente");
          this.$refs.tablaTipoLicencia.refresh();
        })
        .catch(e => {
          this.errorHandler(e);
        });
    },
    //   Muestra Modal de Edicion con los datos de la tabla
    info(item, index, button) {
      this.txtArticulo = item.Descripcion;
      this.txtAntiguedad = item.AntiguedadDias;
      this.txtMinimoDias = item.MinimoDias;
      this.txtMaximoDias = item.MaximoDias;
      this.porcentajeSelected = item.PorcentajeSueldo;
      this.regimenSelected = item.Diasregimen;
      this.idSeleccionado = item.Id;
      this.tipolicencia = item.TipoLicencia_Id;
      this.selected = item.TipoLicencia_Id;
      this.$root.$emit("bv::show::modal", "modalEdicion", button);
    },
    //   Muestra Modal de Edicion con los datos de la tabla
    modalEliminar(item, index, button) {
      this.regimenSelected = item.Regimen;
      this.txtArticulo = item.Articulo;
      this.txtDescripcion = item.Descripcion;
      this.txtDetalle = item.Detalles;
      this.sectorSelected = item.Sector;
      this.idSeleccionado = item.Id;
      this.$root.$emit("bv::show::modal", "modalEliminar", button);
    },
    handleSubmit() {
      this.limpiarFormulario();
      this.$refs.modal.hide();
    },
    limpiarFormulario() {
      this.txtArticulo = "";
      this.txtAntiguedad = "";
      this.txtMinimoDias = "";
      this.txtMaximoDias = "";
      this.porcentajeSelected = null;
      this.regimenSelected = null;
      this.selected = null;
      this.value = null;
    },
    obtenerTiposDeLicencias() {
      TipoLicenciaSvc.getSelectList({ id: 0, sector: "", limit: 100 })
        .then(response => {
          response.data.rows.forEach(element => {
            this.options.push(element);
          });
        })
        .catch(e => {
          console.log("Error: " + e);
          this.errorHandler(e);
        });
    },
    crearTipoLicencia() {
      return TipoLicenciaSvc.crear({
        Regimen: this.regimenSelected,
        Articulo: this.txtArticulo,
        Descripcion: this.txtDescripcion,
        Detalles: this.txtDetalle,
        Sector: this.sectorSelected
      });
    },
    // TODO: REVISAR QUE LOS TIPOS DE LICENCIAS SE CAMEBIEN EFECTIVAMENTE
    cambiarDetalleDiasLicencia() {
      return DetalleDiasLicenciaSvc.cambiar({
        Regimen: this.regimenSelected,
        Articulo: this.txtArticulo,
        Descripcion: this.txtDescripcion,
        Detalles: this.txtDetalle,
        Sector: this.sectorSelected,
        Id: this.idSeleccionado
      });
    },
    // TODO: REVISAR QUE LOS TIPOS DE LICENCIAS SE ELIMINEN EFECTIVAMENTE
    eliminarTipoLicencia() {
      return TipoLicenciaSvc.eliminar({
        Regimen: this.regimenSelected,
        Articulo: this.txtArticulo,
        Descripcion: this.txtDescripcion,
        Detalles: this.txtDetalle,
        Sector: this.sectorSelected,
        Id: this.idSeleccionado
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    myProvider: function(ctx) {
      let promise = TipoLicenciaSvc.getLista({
        id: 0,
        offset: (this.currentPage - 1) * this.perPage,
        limit: this.perPage,
        search: this.filter
      });
      return promise
        .then(r => {
          const items = r.data.rows;
          this.totalRows = r.data.total;
          return items;
        })
        .catch(error => {
          console.log("Error en myProvider");
          this.errorHandler(e);
        });
    }
  },
  created() {
    this.obtenerTiposDeLicencias();
  }
};
</script>

<style>
.primer-fila,
.segunda-fila {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/configuraciones/TipoLicencias.vue